/**
 * @generated SignedSource<<e8defb12120a37aaf18eb712863faea6>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TableBody_project$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"RenderChildRowsComp" | "Rows_project">;
  readonly " $fragmentType": "TableBody_project";
};
export type TableBody_project$key = {
  readonly " $data"?: TableBody_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"TableBody_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Variable",
    "name": "isConditionalFormattingEnabled",
    "variableName": "isConditionalFormattingEnabled"
  }
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "TableBody_project",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "Rows_project"
    },
    {
      "args": (v0/*: any*/),
      "kind": "FragmentSpread",
      "name": "RenderChildRowsComp"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "b3eb4cabe24774b041888ec784130720";

export default node;
